
export enum MetricVarianceCd {
	ABOVE = 'Above',
	BELOW = 'Below',
	NEUTRAL = 'Neutral'}

